module.exports = __webpack_public_path__ + "media/images/cc-by-0d26a71acd3fdf1a2a292c2a68256e58.png";